

import Vue from 'vue'
import Component from "vue-class-component";
import {namespace} from "vuex-class";

import LMLocker from "@/components/locker/modules/LMLocker.vue";
import LockerNav from "@/components/locker/widget/LockerNav.vue";
import LMCredentialsDialog from "@/components/locker/modules/LMCredentialsDialog.vue";
import {IOnOffHandlers} from "bonomo/dist";
import {IModule} from "@/model/Locker/IModule";
import {ILocker} from "@/model/Locker/lockerInterfaces";
import {Watch} from "vue-property-decorator";
import {UrlHelper} from "@/helpers/UrlHelper";
import {IListOrder} from "@/model/Order/orderInterfaces";
import {IShortServiceProvider} from "@/model/shortInterfaces";

const lockerModule = namespace("lockerModule");
const lockerProviderModule = namespace("lockerServiceProviderModule");
const serviceProviderModule = namespace("serviceProviderModule");

  @Component({
    name: 'Locker',
    components: {
      LMLocker,
      LMCredentialsDialog,
      LockerNav,
    }
  })
  export default class InstallLocker extends Vue {

    @lockerModule.Getter('locker')
    private locker!: ILocker;
    @lockerModule.Getter('modules')
    private modules!: IModule[];
    @lockerModule.Getter('lockersOrders')
    private lockersOrders!: IListOrder[];

    @serviceProviderModule.Getter('serviceProviders')
    private providers!: IShortServiceProvider[];

    @serviceProviderModule.Getter('serviceProvidersByIds')
    private serviceProvidersByIds!: (ids: number[]) => IShortServiceProvider[]

    @lockerProviderModule.Getter('lockersProviderIds')
    private connectedIds!: number[];

    private lockerId: number = 0;
    private subscribes: IOnOffHandlers = {};

    @Watch('$route')
    onRouteChanged() {
      this.loadData();
    }

    public get lockerProviders(): IShortServiceProvider[] {
      return this.serviceProvidersByIds(this.connectedIds)
    }

    protected get oldLockerPageUrl(): string {
      return UrlHelper.mayorLockerCells(this.locker.id) + '?stay';
    }

    created() {
      this.subscribes = this.$ons({
        'login.OK': this.loadData,
        'save-locker-block': this.onSaveLockerBlock,
        'save-machine-number': this.onSaveMachineNumber,
        'save-locker-status': this.onSaveLockerStatus,
        'save-screen-orientation': this.onSaveScreenOrientation,
      });
      this.loadData();
    }
    beforeDestroy() {
      this.$offs(this.subscribes);
    }

    protected loadData() {
      this.lockerId = parseInt(this.$route.params.lockerId);
      this.$store.dispatch('lockerModule/fetchLocker', this.lockerId);
      this.$store.dispatch('lockerModule/fetchLockersOrders', this.lockerId);
      this.$store.dispatch('lockerServiceProviderModule/fetchLockersProviderIds', this.lockerId)
      this.$store.dispatch('serviceProviderModule/fetchServiceProviders');
    }
    private onSaveLockerBlock(newBlock: number, data: any) {
      data.block = newBlock;
      this.$store.dispatch('lockerModule/updateLocker', {
        lockerId: this.lockerId,
        pathPart: '/cells/block',
        data
      });
    }
    private onSaveMachineNumber(machineNumber: number) {
      this.$store.dispatch('lockerModule/updateLocker', {
        lockerId: this.lockerId,
        pathPart: '/machine_number',
        data: {
          machine_number: machineNumber,
        }
      });
    }
    private onSaveLockerStatus(status: string) {
      this.$store.dispatch('lockerModule/updateLocker', {
        lockerId: this.lockerId,
        pathPart: '/status',
        data: {status}
      });
    }
    private onSaveScreenOrientation(orientation: string) {
      const screenConfig = this.locker.screenConfig;
      this.$store.dispatch('lockerModule/rotateScreen', {
        lockerId: this.lockerId,
        orientation,
        resolution: screenConfig && screenConfig.resolution,
      });
    }
  }

